
<modal-header
  [hideBackButton]="currentStep !== 2"
  (activatePreviousStep)="changeStep(1)"
  [showProfileImage]=""
  [progressSheetTitle]="headerTitle"
  [progressSheetSubtitle]="currentStep !== 3 ? 'Step ' + currentStep + ' of 2' : 'Referral submitted'"
  [showCloseButton]="true"
  (exitModal)="close()"
></modal-header>
<iris-progress-bar [percentComplete]="progressBarValue"></iris-progress-bar>

<ng-template #spinner >
  <mat-spinner class="spinner" diameter="40">Saving</mat-spinner>
</ng-template>

<div *ngIf="!saving; else spinner" class="content-container">
  <ng-container *ngIf="currentStep === 1">
    <h1 class="iris-h1-responsive">
      Referral details
      <div class="iris-body-responsive" *ngIf="!eligibilityData.psychReferral">
        We’ll match this client to psychiatric providers that fit their needs using the information you give us. They will remain your active therapy client.
      </div>
      <div class="iris-body-responsive" *ngIf="eligibilityData.psychReferral">
        We’ll match this client to therapy providers that fit their needs using the information you give us. They will remain your active psychiatry client.
      </div>  
    </h1>  

    <div class="iris-body-bold">
      Provider type you’re referring to
    </div>
    <div class="iris-body-responsive iris-mb-05">
      {{ eligibilityData.psychReferral ? 'Therapy' : 'Psychiatry'}}
    </div>

    <form  [formGroup]="referralFormGroup" *ngIf="referralFormGroup">
      <div class="iris-mb-05" *ngIf="eligibilityData?.psychReferral">
        <div class="iris-body-bold iris-mb-02">Therapy topic *</div>
        <sonder-form-field class="diagnosis">
          <mat-chip-grid #chipGrid>
            <mat-chip-row
              *ngFor="let specialty of selectedSpecialties"
              [removable]="true"
              (removed)="removeSpecialty(specialty)">
              {{specialty.title}}
              <iris-icon name="cancel" [size]="iconSizes.SM" matChipRemove></iris-icon>
            </mat-chip-row>
            <input type="text"
              #specialtiesInput
              placeholder="&nbsp;&nbsp; To search, type the first three letters of a therapy topic"
              formControlName="specialty"
              data-test="therapy-topic"
              [matAutocomplete]="specialty"
              [matChipInputFor]="chipGrid"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="false"
          >
          </mat-chip-grid>
          <mat-autocomplete #specialty="matAutocomplete" (optionSelected)="specialtiesSelected($event.option.value)">
            <ng-container *ngFor="let option of specialtiesData">
              <mat-option [value]="option">{{option.title}}</mat-option>
            </ng-container>
          </mat-autocomplete>
        </sonder-form-field>
    </div>
    
      <iris-form-field label="Reason for referral">
        <iris-text-area
          class="textarea"
          formControlName="reasonForReferral"
          [autoResizeEnabled]="true"
          data-test="reason-for-referral"
        ></iris-text-area>
      </iris-form-field>


      <div class="iris-body-bold iris-mt-05">Diagnosis</div>
      <div class="iris-legal-responsive iris-mb-02 subtext">Select all that apply. To search type the first three letters of the diagnosis or its code.</div>
      <sonder-form-field class="diagnosis">
        <mat-chip-grid #chipGrid>
          <mat-chip-row
            *ngFor="let diagnosis of selectedDiagnosis"
            [removable]="true"
            (removed)="removeDiagnosis(diagnosis)">
            {{diagnosis.tag}}-{{diagnosis.title}}
            <iris-icon name="cancel" [size]="iconSizes.SM" matChipRemove></iris-icon>
          </mat-chip-row>
          <input type="text"
            #diagnosisInput
            placeholder="To search type the first three letters of a diagnosis"
            formControlName="diagnosis"
            data-test="diagnosis"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="false"
        >
        </mat-chip-grid>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="diagnosisSelected($event)">
          <ng-container *ngFor="let option of filterOptions$ | async">
            <mat-option [value]="option">{{option.tag}}-{{option.title}}</mat-option>
          </ng-container>
        </mat-autocomplete>
      </sonder-form-field>


      <iris-form-field class="iris-mt-05 preference"
       label="Does {{patient.firstName}} have any preferences for their new provider you'd like to include?"
       helperText="e.g. a woman provider, someone who speaks Spanish, etc"
       [showOptionalTag]="false"
       >
        <iris-text-area
          class="textarea"
          formControlName="preferences"
          data-test="preferences"
          [autoResizeEnabled]="true"
        ></iris-text-area>
      </iris-form-field>

      <iris-button-container class="iris-mt-05" [alignment]="IrisButtonContainerAlignments.END">
        <iris-button
          data-test="next"
          (click)="changeStep(2)"
          [buttonType]="IrisButtonTypes.PRIMARY"
          [typeAttribute]="IrisButtonTypeAttributeOptions.SUBMIT"
          [disabled]="referralFormGroup.invalid"

        >
          Next
        </iris-button>
      </iris-button-container>
    </form>

  </ng-container>

  <ng-container *ngIf="currentStep === 2">
    <form [formGroup]="confirmationFormGroup">
      <h1 class="iris-h1-responsive">
        Confirmation
      </h1>
      <div class="iris-body-responsive">
        We’ll share your contact info, referral reason, and diagnoses with the new provider matches. They’ll also have access to this client’s CQ scores.
        </div>
  
      <h4 class="iris-h4-responsive">
        Please click to confirm the following
      </h4>
      <iris-checkbox
        formControlName="spoken"
        class="confirmation-box"
        data-test="confirmation-box-1"
      >
        I, {{provider.fullName}}, declare that I have spoken to {{patient.firstName}} about this referral.
        <div class="checkbox-subtitle">We’ll match clients to {{ eligibilityData.psychReferral ? 'therapist' : 'psychiatrist'}}(s) who should be reaching out to them once this form is completed, so it’s important that the client is expecting this communication.</div>
      </iris-checkbox>

      <iris-checkbox
        formControlName="accurate"
        class="confirmation-box"
        data-test="confirmation-box-2"
      >
        I, <span data-dd-privacy="mask">{{provider.fullName}}</span>, declare this information to be accurate and complete.
      </iris-checkbox>
    </form>

    <iris-button-container class="iris-mt-05" [alignment]="IrisButtonContainerAlignments.END">
      <iris-button
        data-test="submit"
        (click)="submit()"
        [buttonType]="IrisButtonTypes.PRIMARY"
        [typeAttribute]="IrisButtonTypeAttributeOptions.SUBMIT"
        [disabled]="confirmationFormGroup.invalid"
      >
        Submit
      </iris-button>
    </iris-button-container>
  </ng-container>

  <ng-container *ngIf="currentStep === 3">
    <div class="success-container">

      <img class="image" src="/assets/images/success.svg" alt="">
      <h3 class="iris-h3-responsive">Referral submitted!</h3>
      <div class="iris-body-responsive">
        We’ll reach out to {{patient.firstName}} shortly with next steps.
      </div>
        <iris-button 
          class="iris-mt-05"
          (click)="close()"
          [buttonType]="IrisButtonTypes.PRIMARY"
          [typeAttribute]="IrisButtonTypeAttributeOptions.SUBMIT"
        >
          Close
        </iris-button>
    </div>
  </ng-container>
</div>
